const SITE_KEY = "6LeZWjgtAAAAADCht2BP3c_XSw_OKFkNfTBYuINk";

export async function getCaptchaToken(action = "submit") {
  return new Promise((resolve) => {
    if (!window.grecaptcha || !window.grecaptcha.execute) {
      resolve(null);
      return;
    }
    try {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(SITE_KEY, { action })
          .then(resolve)
          .catch(() => resolve(null));
      });
    } catch {
      resolve(null);
    }
  });
}

export default function ReCaptcha() {
  return null;
}

export function resetCaptcha() {}
